import axios from 'axios';
import {
  FETCH_APPLICATION_DATA_SUCCESS,
  FETCH_APPLICATION_DATA_FAILURE,
  STORE_APP_DATA_URLS,
  SHOW_MODAL,
  SHOW_LOADER,
  STORE_LANGUAGE_CODE,
} from './ActionTypes';
import { SERVICE_CONSTANTS } from '../../../shared/_constants/services.constants';
import config from '../../../services/Auth/AuthConfig';

/**
 * Action to fetch the application data
 */
export function fetchApplicationData(languageCode) {
  return function (dispatch) {
    dispatch(showLoader(true));
    return axios
      .get('/kiosk/api/applications', {
        headers: {
          'Accept-Language': languageCode ? languageCode : 'en',
        },
      })
      .then(({ data }) => {
        dispatch(fetchApplicationDataSuccess(data));
        dispatch(showLoader(false));
      })
      .catch((error) => {
        dispatch(fetchApplicationDataFailure(error));
        dispatch(showLoader(false));
      });
  };
}
/**
 * Action to return Success response from api
 * @param  data
 */
function fetchApplicationDataSuccess(data) {
  return {
    type: FETCH_APPLICATION_DATA_SUCCESS,
    payload: data.AppData,
  };
}
/**
 * Action to return Failure response from api
 * @param  error
 */
function fetchApplicationDataFailure(error) {
  return {
    type: FETCH_APPLICATION_DATA_FAILURE,
    payload: error,
  };
}
/**
 * Action to store the application redirection urls
 */
export function storeRedirectionUrls(openedTab) {
  return {
    type: STORE_APP_DATA_URLS,
    openedTab,
  };
}

/**
 * Action to show Modal
 * @param isModal
 */
export function showModal(isModal) {
  return {
    type: SHOW_MODAL,
    isModal,
  };
}

/**
 * Action to call user activities api
 * if response status is 204 : show welcome modal
 * otherwise welcome modal not shown
 */
export function getUserActivities(token) {
  return function (dispatch) {
    dispatch(showLoader(true));
    const appURL = SERVICE_CONSTANTS.getUserActivity.replace(
      '<applicationObjectId>',
      config.appId
    );
    return axios
      .get(`${SERVICE_CONSTANTS.baseURL + appURL}`, {
        mode: 'no-cors',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json; application/vnd.weir-iamservice.v1',
        },
      })
      .then((response) => {
        if (response.status === 204) {
          dispatch(showModal(true));
        }
        dispatch(showLoader(false));
      })
      .catch((error) => {
        dispatch(showLoader(false));
        // console.log(`failure from User activities api${error}`);
      });
  };
}

/**
 * Action to show Loader
 * @param isLoader
 */
export function showLoader(isLoader) {
  return {
    type: SHOW_LOADER,
    isLoader,
  };
}
/**
 * Store the language code
 * @param code
 */
export function storeLanguageCode(code) {
  return {
    type: STORE_LANGUAGE_CODE,
    languageCode: code,
  };
}
